export default Object.freeze({
  REFRESH_CASE_INFO: 'REFRESH_CASE_INFO',
  RESOLVED_STATUS: 'RESOLVED_STATUS',
});
